<template>
  <div class="comm-schedule">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
      <div style="display: flex; gap: 8px;">
        <el-button type="success" @click="openNewCommissionerDialog">
          <i class="el-icon-user"></i>{{$t('Yeni_komissar')}}</el-button>
        <el-button type="primary" :loading="loading" :disabled="!canCreateSchedule" @click="createNewSchedule">
          <i class="el-icon-plus"></i>{{$t('Yeni_cədvəl')}}</el-button>
      </div>

      <el-date-picker v-model="selectedMonth" type="month" format="MMMM yyyy" :placeholder="$t('Ay_seçin')"
        @change="fetchScheduleData" style="width: 30% !important; " />
    </div>
    <el-table :data="allTableRows" border style="width: 100%; table-layout: fixed;" size="small"
      v-loading="loadingTable" :row-class-name="rowClassName" :cell-class-name="getCellClass" :cell-style="cellStyle"
      :show-header="false" :span-method="spanMethod">
      <el-table-column prop="commissionerName" width="180" fixed="left">
        <template #default="{ row, $index }">
          <div v-if="$index > 1" class="name-cell d-flex justify-between items-center">
            <b>{{ row.commissionerName }}</b>
            <i class="el-icon-delete delete-icon" @click.stop="confirmDelete(row)"></i>
          </div>
          <b v-else class="name-cell">{{ row.commissionerName }}</b>
        </template>
      </el-table-column>
      <el-table-column v-for="day in daysInMonth" :key="day.day" align="center" :min-width="36">
        <template #default="{ row, $index }">
          <span v-if="$index <= 1" class="cell-text no-wrap">
            {{ (row.schedule[day.day] && row.schedule[day.day].display) || '' }}
          </span>

          <div v-else class="cell-wrapper" @click="openEditDialog(row, day.day)">
            <el-tooltip effect="dark" :content="(row.schedule[day.day] && row.schedule[day.day].fullLabel) || ''"
              placement="top" :open-delay="250">
              <span class="cell-text no-wrap">
                {{ (row.schedule[day.day] && row.schedule[day.day].display) || '' }}
              </span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="newDialogVisible" :title="$t('Yeni_komissar')" width="420px" @closed="resetNewForm">
      <el-form ref="newFormRef" :model="newForm" :rules="rules" label-width="110px" size="small">
        <el-form-item :label="$t('Komissar')" prop="commissionerId">
          <el-select v-model="newForm.commissionerId" filterable :placeholder="$t('Seçin')" style="width: 100%">
            <el-option v-for="o in commissioners" :key="o.id" :label="o.name" :value="o.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" :loading="saving" @click="submitNewCommissioner">{{$t('Yadda_saxla')}}</el-button>
        <el-button @click="newDialogVisible = false">{{$t('İmtina')}}</el-button>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="editDialogVisible" :title="$t('ş_qrafiki_Düzəliş')" width="440px" @closed="resetEditForm">
      <el-form ref="editFormRef" :model="editForm" label-width="110px" size="small">
        <el-form-item :label="$t('Komissar')">
          <el-input :value="editForm.commissionerName" disabled />
        </el-form-item>

        <el-form-item :label="$t('Tarix')">
          <el-input :value="editForm.date" disabled />
        </el-form-item>

        <el-form-item :label="$t('ş_rejimi')">
          <el-select v-model="editForm.selectedValue" filterable clearable :placeholder="$t('Seçin')" style="width: 100%">
            <el-option v-for="shift in workShifts" :key="shift.id" :label="shift.label + ' (' + shift.code + ')'"
              :value="'shift_' + shift.id" />
            <el-option :label="$t('Köməkçi')" value="assistant" />
            <el-option :label="$t('Qeyriiş_günü')" value="none" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" :loading="saving" @click="submitEdit">{{$t('Yadda_saxla')}}</el-button>
        <el-button @click="editDialogVisible = false">{{$t('İmtina')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetCommSchedule,
  CommScheduleClone,
  CreateCommSchedule,
  UpdateCommSchedule,
  DeleteCommSchedule
} from "../../services/commschedule";
import { usersbyrole } from "../../services/sales";
import { GetCommWorkShifts } from "../../services/cls";

export default {
  name: "AccidentCommSchedule",
  data() {
    return {
      selectedMonth: new Date(),
      daysInMonth: [],
      scheduleRows: [],
      workShifts: [],
      commissioners: [],
      allTableRows: [],
      loading: false,
      loadingTable: false,
      saving: false,
      newDialogVisible: false,
      editDialogVisible: false,
      newForm: { commissionerId: null },
      editForm: {
        scheduleId: null,
        commissionerId: null,
        commissionerName: "",
        day: "",
        date: "",
        selectedValue: null
      },
      rules: {
        commissionerId: [{ required: true, message: "Komissarı seçin", trigger: "change" }]
      },
      currentUserId: 5,
      nextMonthHasSchedule: false
    };
  },
  computed: {
    canCreateSchedule() {
      const now = new Date();
      const next = new Date(now.getFullYear(), now.getMonth() + 1, 1);
      const selected = this.selectedMonth instanceof Date ? this.selectedMonth : new Date(this.selectedMonth);
      const ym = d => d.getFullYear() * 12 + d.getMonth();
      return ym(selected) <= ym(next) && !this.nextMonthHasSchedule;
    }
  },
  created() {
    this.generateDays();
    this.init();
  },
  methods: {
    async init() {
      await Promise.all([
        this.fetchCommissioners(),
        this.fetchWorkShifts()
      ]);

      await Promise.all([
        this.fetchScheduleData(),
        this.updateNextMonthFlag()
      ]);
    },

    async updateNextMonthFlag() {
      try {
        const now = new Date();
        const next = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        const res = await GetCommSchedule(next.getFullYear(), next.getMonth() + 1);
        const rows = res?.data.data || [];
        this.nextMonthHasSchedule = rows.length > 0;
      } catch (error) {
        console.error('Error checking next month:', error);
        this.nextMonthHasSchedule = false;
      }
    },

    async fetchCommissioners() {
      try {
        const res = await usersbyrole(4);
        console.log('Commissioners response:', res.data);
        this.commissioners = res.data || [];
      } catch (error) {
        console.error('Error fetching commissioners:', error);
        this.commissioners = [];
      }
    },

    async fetchWorkShifts() {
      try {
        const res = await GetCommWorkShifts();
        const rows = res.data.data || [];
        this.workShifts = rows.map(x => ({
          id: x.id,
          code: x.code,
          label: `${(x.timeFrom || "").substring(0, 5)}-${(x.timeTo || "").substring(0, 5)}`
        }));
      } catch (error) {
        console.error('Error fetching work shifts:', error);
        this.workShifts = [];
      }
    },

    toRoman(n) {
      const map = { 1: "I", 2: "II", 3: "III", 4: "IV", 5: "V", 6: "VI", 7: "VII" };
      return map[n] || "";
    },

    generateDays() {
      const days = [];
      const base = new Date(this.selectedMonth);
      const y = base.getFullYear();
      const m = base.getMonth();
      const total = new Date(y, m + 1, 0).getDate();
      for (let i = 1; i <= total; i++) {
        const d = new Date(y, m, i);
        const wd = d.getDay();
        days.push({ day: String(i).padStart(2, "0"), weekRoman: this.toRoman(wd === 0 ? 7 : wd) });
      }
      this.daysInMonth = days;
    },

    async fetchScheduleData() {
      this.loadingTable = true;
      this.generateDays();

      try {
        const year = this.selectedMonth.getFullYear();
        const month = this.selectedMonth.getMonth() + 1;
        const res = await GetCommSchedule(year, month);
        const items = res.data.data || [];

        const shiftsMap = new Map(this.workShifts.map(w => [w.id, w]));
        const commissionsMap = new Map(this.commissioners.map(c => [c.id, c]));

        const grouped = {};

        items.forEach(item => {
          const day = new Date(item.workDate).getDate().toString().padStart(2, "0");
          const commissionerId = item.commId;

          if (!grouped[commissionerId]) {
            const cm = commissionsMap.get(commissionerId);
            grouped[commissionerId] = {
              commissionerId,
              commissionerName: cm?.name || `ID: ${commissionerId}`,
              schedule: {}
            };
          }

          if (item.isAssistant) {
            grouped[commissionerId].schedule[day] = {
              display: "K",
              fullLabel: "Köməkçi",
              scheduleId: item.id,
              workShiftId: item.workShiftId || null,
              code: null
            };
          } else {
            const shift = shiftsMap.get(item.workShiftId);
            const displayCode = item.code || shift?.code || "";
            grouped[commissionerId].schedule[day] = {
              display: displayCode,
              fullLabel: shift
                ? `${shift.label} (${displayCode})`
                : displayCode || "",
              scheduleId: item.id,
              workShiftId: item.workShiftId || null,
              code: item.code || null
            };
          }
        });

        const headerRow = { commissionerName: "Komissar", schedule: {} };
        const weekRow = { commissionerName: "", schedule: {} };

        this.daysInMonth.forEach(d => {
          headerRow.schedule[d.day] = { display: d.day };
          weekRow.schedule[d.day] = { display: d.weekRoman };
        });

        this.allTableRows = [headerRow, weekRow, ...Object.values(grouped)];
      } catch (error) {
        console.error('Error fetching schedule:', error);
        this.$message.error("Xəta baş verdi");
      } finally {
        this.loadingTable = false;
      }
    },

    async confirmDelete(row) {
      try {
        await this.$confirm(
          `Komissar "${row.commissionerName}" cədvəldən silinsin?`,
          "Təsdiqlə",
          { type: "warning", confirmButtonText: "Bəli", cancelButtonText: "Xeyr" }
        );
        const payload = {
          commId: row.commissionerId,
          year: this.selectedMonth.getFullYear(),
          month: this.selectedMonth.getMonth() + 1,
          commandUserId: this.currentUserId,
        };
        await DeleteCommSchedule(payload);
        this.$message.success("Uğurlu əməliyyat!");
        await this.fetchScheduleData();
      } catch {
      }
    },

    async createNewSchedule() {
      const now = new Date();
      const next = new Date(now.getFullYear(), now.getMonth() + 1, 1);

      const monthNames = {
        0: "Yanvar", 1: "Fevral", 2: "Mart", 3: "Aprel",
        4: "May", 5: "İyun", 6: "İyul", 7: "Avqust",
        8: "Sentyabr", 9: "Oktyabr", 10: "Noyabr", 11: "Dekabr"
      };

      const nextMonthName = `${next.getFullYear()} ${monthNames[next.getMonth()]}`;

      try {
        await this.$confirm(
          `${nextMonthName} ayı üçün cədvəl yaratmaq istədiyinizə əminsiniz?`,
          "Təsdiqlə",
          { type: "warning", confirmButtonText: "Bəli", cancelButtonText: "Xeyr" }
        );
      } catch {
        return;
      }

      const date = this.selectedMonth instanceof Date ? this.selectedMonth : new Date(this.selectedMonth);
      const ym = d => d.getFullYear() * 12 + d.getMonth();
      const selected = date;

      if (ym(selected) > ym(next)) {
        return this.$message.warning("Yalnız növbəti ay üçün cədvəl yaratmaq olar");
      }

      await this.updateNextMonthFlag();

      if (this.nextMonthHasSchedule) {
        return this.$message.warning("Növbəti ay üçün cədvəl artıq mövcuddur");
      }

      this.loading = true;
      try {
        await CommScheduleClone(this.currentUserId);
        this.$message.success("Uğurlu əməliyyat!");

        this.selectedMonth = next;

        await this.updateNextMonthFlag();
        await this.fetchScheduleData();
      } catch {
        this.$message.error("Xəta baş verdi");
      } finally {
        this.loading = false;
      }
    },

    openNewCommissionerDialog() {
      this.newForm = { commissionerId: null };
      this.newDialogVisible = true;
    },

    resetNewForm() {
      this.$refs.newFormRef && this.$refs.newFormRef.clearValidate();
    },

    resetEditForm() {
      this.$refs.editFormRef && this.$refs.editFormRef.clearValidate();
    },

    async submitNewCommissioner() {
      this.$refs.newFormRef.validate(async ok => {
        if (!ok) return;
        this.saving = true;
        try {
          const payload = {
            commId: this.newForm.commissionerId,
            year: this.selectedMonth.getFullYear(),
            month: this.selectedMonth.getMonth() + 1,
            commandUserId: this.currentUserId,
          };
          await CreateCommSchedule(payload);
          this.$message.success("Uğurlu əməliyyat!");
          this.newDialogVisible = false;
          await this.fetchScheduleData();
        } catch {
          this.$message.error("Xəta baş verdi");
        } finally {
          this.saving = false;
        }
      });
    },

    openEditDialog(row, day) {
      const y = this.selectedMonth.getFullYear();
      const m = this.selectedMonth.getMonth() + 1;
      const cell = row.schedule[day] || {};

      let selectedValue = "none";

      if (cell.display === "K") {
        selectedValue = "assistant";
      } else if (cell.workShiftId) {
        selectedValue = "shift_" + cell.workShiftId;
      }

      this.editForm = {
        scheduleId: cell.scheduleId || null,
        commissionerId: row.commissionerId,
        commissionerName: row.commissionerName,
        day,
        date: `${day}.${String(m).padStart(2, "0")}.${y}`,
        selectedValue: selectedValue
      };

      this.editDialogVisible = true;
    },

    async submitEdit() {
      this.saving = true;

      try {
        let workShiftId = null;
        let isAssistant = false;

        if (this.editForm.selectedValue === "assistant") {
          isAssistant = true;

        } else if (this.editForm.selectedValue && this.editForm.selectedValue.startsWith("shift_")) {
          workShiftId = parseInt(this.editForm.selectedValue.replace("shift_", ""));

        } else {
          workShiftId = null;
          isAssistant = false;
        }

        const payload = {
          id: this.editForm.scheduleId,
          workShiftId: workShiftId,
          isAssistant: isAssistant,
          commandUserId: this.currentUserId,
        };

        await UpdateCommSchedule(payload);
        this.$message.success("Uğurlu əməliyyat!");
        this.editDialogVisible = false;
        await this.fetchScheduleData();

      } catch (error) {
        console.error("Error:", error);
        this.$message.error("Xəta baş verdi");
      } finally {
        this.saving = false;
      }
    },

    rowClassName({ rowIndex }) {
      if (rowIndex === 0) return "row--days";
      if (rowIndex === 1) return "row--week";
      return "";
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      const styles = {};

      if (rowIndex > 1) {
        styles.padding = "0";
        styles.height = "32px";
      } else {
        styles.padding = "2px 0";
      }

      if (rowIndex > 1 && columnIndex > 0 && this.daysInMonth && this.daysInMonth[columnIndex - 1]) {
        const key = this.daysInMonth[columnIndex - 1].day;
        const cellData = row.schedule && row.schedule[key];

        if (cellData && cellData.display && cellData.display.trim() !== "") {
          const displayValue = cellData.display.trim().toUpperCase();
          if (displayValue === "М" || displayValue === "M" || displayValue === "MƏZUNIYYƏT") {
            styles.backgroundColor = "rgb(102,180,255) !important";
            styles.color = "#ffffff !important";
          }
          else {
            styles.backgroundColor = "#ffffff";
            styles.color = "#000";
          }
        }
        else {
          styles.backgroundColor = "#cce5ff";
          styles.color = "#000";
        }
      }

      return styles;
    },

    getCellClass({ row, column, rowIndex }) {
      if (rowIndex === 0 || rowIndex === 1) return "cell--service";
      if (column.property && row.schedule) {
        const key = this.daysInMonth[column.index - 1]?.day;
        if (key && row.schedule[key]) {
          const val = row.schedule[key].display;
          if (!val || val.trim() === "" || val === "Мəzuniyyət" || val === "X") return "bg-red";
          if (val === "Köməkçi") return "bg-blue";
          return "bg-green";
        }
      }
      return "";
    },

    spanMethod({ columnIndex, rowIndex }) {
      if (columnIndex === 0 && rowIndex === 0) return { rowspan: 2, colspan: 1 };
      if (columnIndex === 0 && rowIndex === 1) return { rowspan: 0, colspan: 0 };
    }
  }
};
</script>

<style scoped>
::v-deep(.el-table__body td) {
  position: relative;
  overflow: hidden;
}

::v-deep .cell-wrapper .cell-text {
  color: inherit !important;
  position: relative;
  z-index: 1;
}

::v-deep .el-table__body tr>td .cell {
  padding: 0 !important;
}

::v-deep .el-table__body tr>td:first-child .cell {
  padding: 8px !important;
}

::v-deep .el-table__body .row--days .cell,
::v-deep .el-table__body .row--week .cell {
  padding: 2px 0 !important;
}

.btns {
  display: flex;
  gap: 8px;
}

.name-cell {
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.delete-icon {
  font-size: 14px;
  color: #f56c6c;
  cursor: pointer;
}

.cell-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}


.cell-text {
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell--service {
  border-bottom: 0 !important;
}
</style>